<script setup lang="ts">
import { reactive, type PropType } from "vue";
import { emit } from "@/utils/eventBus";
import SocialMedia from "../SocialMedia.vue";
import { useRoute, useRouter } from "vue-router";
import { useGlobalData } from "@/utils/useGlobal";

const { isPc, currentMenuIndex } = useGlobalData();

const route = useRoute();
defineProps({
  list: {
    type: Array as PropType<IMenu[]>,
    default: () => [],
  },
});

const emits = defineEmits<{
  (e: "callback"): void;
}>();

const router = useRouter();

const menu: { list: IMenu[] } = reactive({
  list: [
    {
      name: "首页",
      type: 0,
    },
    // {
    //   name: "游戏推荐官",
    //   type: 1,
    // },
    // {
    //   name: "游戏推荐官",
    //   type: 2,
    // },
    // {
    //   name: "预约奖励",
    //   type: 3,
    // },
    {
      name: "元神",
      type: 1,
    },
    // {
    //   name: "封神档案",
    //   type: 2,
    // },
    {
      name: "玩法特色",
      type: 2,
    },
    {
      name: "朝歌见闻",
      type: 3,
    },
    {
      name: "游戏攻略",
      type: 4,
    },
    {
      name: "官方阵地",
      type: 5,
    },
  ],
});

function goToSection(type: number, index: number) {
  currentMenuIndex.value = index;
  if (route.name !== "home") {
    router.push({
      name: "home",
      // query: {
      //   id: type,
      // },
    });
  } else {
    emit("handleScroll", type);
  }
  emits("callback");
}
</script>
<template>
  <ul class="menu-content">
    <template v-for="(item, index) in menu.list" :key="item.name">
      <li class="menu-item" :class="{ active: index === currentMenuIndex }">
        <div class="menu-button" @click="goToSection(item.type, index)">
          <span class="menu-text">{{ item.name }}</span>
        </div>
      </li>
    </template>
  </ul>
  <div v-if="!isPc" class="menu-socia">
    <SocialMedia />
  </div>
</template>
<style lang="less" scoped>
.menu-content {
  padding-top: 1.2rem;
}

.menu-item {
  position: relative;
  width: 100%;
  margin-bottom: 0.26rem;
  overflow: hidden;
  font-family: "HYJiangNanKaiSongW", sans-serif;
  font-size: 0.36rem;
  color: #a77f51;

  &.active {
    color: #dfc9af;
    .menu-text {
      display: flex;
      align-items: center;
      justify-content: center;

      &::before,
      &::after {
        display: inline-block;
        width: 0.14rem;
        height: 0.13rem;
        content: "";
        background: url("~/images/menu/icon.png") no-repeat 0 0 / 100% 100%;
      }

      &::before {
        margin-right: 0.12rem;
      }

      &::after {
        margin-left: 0.12rem;
        transform: rotate(180deg);
      }
    }
  }
}

.menu-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &::after {
    width: 2.55rem;
    height: 0.03rem;
    margin-top: 0.26rem;
    content: "";
    background: url("~/images/menu/line.png") no-repeat 0 0 / 100% 100%;
  }

  transform: translateY(110%);
  animation: link-appear 1.2s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

.Loop(@index) when(@index < 9) {
  .menu-item:nth-of-type(@{index}) {
    &::after,
    .menu-button {
      animation-delay: calc((1s / 2) * @index * 0.125);
    }
  }

  .Loop(@index+1);
}

.Loop(1);

.menu-socia {
  :deep(.contact-wrap) {
    display: flex;
    justify-content: center;
    margin-top: 0.4rem;
    opacity: 0;
    transform: none;
    animation: fadeUp 0.3s 0.5s forwards;
  }
}

@keyframes nav-line {
  0% {
    transform: scaleX(0);
    transform-origin: 0 50%;
  }

  35% {
    transform: scaleX(1.001);
    transform-origin: 0 50%;
  }

  65% {
    transform: scaleX(1.001);
    transform-origin: 100% 50%;
  }

  100% {
    transform: scaleX(1);
    transform-origin: 100% 50%;
  }
}

@keyframes link-appear {
  0%,
  25% {
    transform: translateY(110%);
  }

  50%,
  100% {
    transform: translateY(0);
  }
}
</style>
